import React, {useEffect, useReducer} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import CircularProgress from '@mui/material/CircularProgress';
import {useParams} from "react-router";
import Bugsnag from "@bugsnag/js";
import { useNavigate } from 'react-router-dom';
import {GeneralVehicleInfoGrid} from "./generalVehicleInfoGrid";
import {InspectionSelection} from "./inspectionSelection";
import {VehiclePartConditionCarousel} from "./vehiclePartConditionCarousel";
import {VehicleHeader} from "./vehicleHeader";
import {Footer} from "../footer";
import {INITIAL_DATA_LOADED, SELECTION_CHANGED, SET_PHOTOS_LOADING} from "../../constants/actions";
import apiService from "../../services/apiService";
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import "../../styles/vehicle/vehicle.css"
import {VehicleStateProvider} from "../../reducers/vehicleReducer";
import {NotAuthorized} from "../notAuthorized";
import IconButton from '@mui/material/IconButton';

export const vehicleReducer = function(state, action) {
    switch(action.type) {
        case INITIAL_DATA_LOADED:
            if(action.payload.authorized == false) {
                return {...state, ...action.payload};
            }
            
            const makeAndModel = (action.payload.shareVehicleDetails.make != null ? action.payload.shareVehicleDetails.make : "") + " " + (action.payload.shareVehicleDetails.model != null ? action.payload.shareVehicleDetails.model : "");
            return {...state, ...action.payload, makeAndModel};
        case SELECTION_CHANGED:
            state.shareVehicleConditionPhotos.photos = action.payload.photos;
            state.shareVehicleConditionPhotos.thumbnails = action.payload.thumbnails;
            return {...state, selectedInspectionId: action.payload.selectedIndex, photosLoading: false};
        case SET_PHOTOS_LOADING:
            return {...state, photosLoading: action.payload.photosLoading};
    }
}

export function Vehicle() {
    const initialState = {isLoading: true, selectedInspectionId: 0, photosLoading: false};
    const params = useParams();
    const [state, dispatch] = useReducer(vehicleReducer, initialState);
    const navigate = useNavigate();

    useEffect(async () => {
        await getInitialData();
    }, []);

    const getInitialData = async () => {
        if (params == undefined) {
            navigate('/notAuthorized');
            return;
        }

        try {
            const {data} = await apiService.dtoService.getDto(params.subdomain, 'Vehicle', params.objectId, params.token);
            dispatch({type: INITIAL_DATA_LOADED, payload: {...data, isLoading: false}})
        } catch (error) {
            Bugsnag.notify(error)
            navigate('/notAuthorized');
        }
    };

    function handleVehicleLink() {
        window.open(state.sharePageSettings.vehicleDetailsUrl, '_blank');
    }
    
    return (
        <>
            { state.isLoading == true ?
                <Stack direction="row" alignItems="center" justifyContent="center" className="loadingHome">
                    <CircularProgress />
                </Stack>
                : state.authorized == false ? 
                <NotAuthorized tenantId={state.tId} />    :
                <VehicleStateProvider initialState={initialState} reducer={{dispatch}}>
                    <div>
                        <React.Fragment>
                            <CssBaseline />
                            <div className="flexContainer">
                                <VehicleHeader tenantId={state.tId} />

                                <div className="main">
                                    <Container fixed>
                                        <Container maxWidth="lg" sx={{mt: 5, mb: 3}}>
                                            <Chip label={state.makeAndModel} icon={<DirectionsCarIcon />} color="success" style={{padding: '10px'}}/>
                                            <Chip
                                                label={'Fahrzeug ' + state.shareVehicleDetails.vehicleId}
                                                color="success"
                                                style={{marginLeft: '6px'}}
                                            />
                                            <span className="vehicleInfo">For vehicle information click </span>
                                            <IconButton aria-label="shareIcon" onClick={handleVehicleLink} sx={{verticalAlign:'bottom'}}>
                                                <IosShareRoundedIcon color="success" fontSize="small" />
                                            </IconButton>
                                        </Container>
                                        <Container sx={{mb: 2}}>
                                            <GeneralVehicleInfoGrid shareVehicleDetails={state.shareVehicleDetails} />
                                        </Container>
                                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                                            <Chip label="Zustandsaufnahmen"  color="default" className="status-chip" style={{marginLeft: 24}}/>
                                            <InspectionSelection inspections={state.shareVehicleConditionPhotos.inspections} selectedInspectionId={state.selectedInspectionId} />
                                        </Stack>
                                        <hr color="green" style={{marginLeft: 24, marginRight: 24}}/>
                                        <Container maxWidth="lg" style={{minHeight: '500px'}}>
                                            { state.photosLoading == true ?
                                                <Stack direction="row" alignItems="center" justifyContent="center" className="loadingHome">
                                                    <CircularProgress />
                                                </Stack>
                                                :  <Box className="carousel-box" sx={{
                                                    backgroundColor: '#fff',
                                                }}>
                                                    <VehiclePartConditionCarousel photoState={{photos: state.shareVehicleConditionPhotos.photos, thumbnails: state.shareVehicleConditionPhotos.thumbnails}} />
                                                </Box> }
                                        </Container>
                                        <br/>

                                    </Container>
                                </div>

                                <Footer imprintUrl={state.sharePageSettings.imprintUrl} />
                            </div>
                        </React.Fragment>
                    </div>
                </VehicleStateProvider>
            }
        </>
    );
}
